<template>
    <div>
        <div class="title-lable-error">
            <span class="ml-3">Cannot renewal !</span>
        </div>
        <div
            class="d-flex flex-row mt-3 ml-3"
            style="color: #757575; font-size: 0.85rem"
        >
            <div>
                The machine is not ready. Cannot make rental plan in this state.
            </div>
        </div>
    </div>
</template>

<script>
import base from "@/scripts/base";

export default {
    extends: base,
};
</script>